import React from "react";
import ManageSurveys from "./ManageSurveys";

export default function () {
  return <ManageSurveys />
}
